<style>
.popover {
  z-index: 999 !important;
  width: 100%;
  background: rgba(255, 255, 255, 0.93);
}

@media (min-width: 768px) {
  .popover {
    min-width: 320px;
  }
}

.notifications-list {
  margin: -0.5rem -0.75rem;
}

.notifications-list .list-group-item {
  border: 0;
  background-color: transparent;
}

.notifications-list .separator {
  margin: 1px 15px;
}

.notifications-list .list-group-item:hover {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}

.notifications-list-item-title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<template>
  <b-popover
    ref="popover"
    triggers="manual"
    :placement="placement"
    :target="target"
    :show.sync="display"
  >
    <template v-slot:title>
      What's New
      <button
        type="button" class="close ml-5 anchor-modal-close-button"
        @click="display = false" aria-label="Close"
      >
        <span aria-hidden="true" class="d-inline-block">&times;</span>
      </button>
    </template>

    <b-list-group class="notifications-list" v-if="length">
      <div
        v-for="(item, idx) in items"
        :key="item.title"
      >
        <b-list-group-item
          class="flex-column align-items-start pointer-cursor"
          @click="$emit('item-clicked', item)"
        >
          <div class="d-flex w-100 justify-content-between">
            <span class="mb-1 notifications-list-item-title">
              {{item.title}}
            </span>
            <small>
              {{item.days}}
            </small>
          </div>

          <p class="mb-1">
            {{ item.headline || '-' }}
          </p>
        </b-list-group-item>
        <hr class="separator" v-if="idx !== length - 1"/>
      </div>
    </b-list-group>
    <div v-else class="text-center">
      It appears you have no new notifications
    </div>
  </b-popover>
</template>

<script>
import helper from '@/libs/helper';


export default {
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: String,
  },
  data: () => ({
    display: false,
  }),
  computed: {
    items() {
      const now = new Date();

      return this.$store.getters.notifications.map((notification) => {
        const item = helper.copy(notification);
        const daysPassed = helper.dayDiff(now, new Date(notification.created));
        item.days = `${daysPassed} ${daysPassed === 1 ? 'day' : 'days'} ago`;
        return item;
      });
    },
    length() {
      return this.items.length;
    },
  },
  methods: {
    toggleDisplay() {
      this.display = !this.display;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/profile/notifications/NotificationsPopover.vue